const initialState = {
  trackerId: '',
  studentType: '',
  instructor: '',
  course: '',
  tabValue: 0,
};

export default initialState;
